<template>
  <div class="main row m-0">
    <div class="col-md-6 left-column justify-content-center center">
      <header class="d-flex justify-content-center">
        <img v-if="whitelabelReady" class="logo" alt="Omni Business" :src="whitelabelLogo" />
      </header>
      <div class="top-options">
        <span
          style="    background: #752DE6;
      color: white;
      font-size: 12px;
      padding: 5px 11px;
      border-radius: 100px;
      font-weight: 500;max-height: 2.2em;"
          ><a style="color: white;" href="https://yup.chat">{{ $t('app.back-to-website') }}</a></span
        >
        <div class="row justify-content-center align-items-center">
          <p style="margin-right: 10px;margin-bottom: 0px;">Selecione o idioma</p>
          <OptLangDropdown />
        </div>
      </div>
      <div class="row mt-3">
        <template v-if="routing">
          <div class="col-md-12">
            <router-view />
          </div>
        </template>
        <div class="col-12 sub-intro" v-else>
          <h1>
            {{ $t('auth.welcome') }}
          </h1>
          <h2>
            {{ $t('auth.subtitle') }}
          </h2>
          <div class="row">
            <div class="col-12 col-md-4 mb-4">
              <ButtonComponent @click="routing = true" is-block>Login</ButtonComponent>
            </div>
            <div class="col-12 col-md-4">
              <ButtonComponent variant="secondary" @click="launchRegister()" is-block>{{ $t('app.register') }} </ButtonComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 right-column d-none d-md-block">
      <h3 style="color: white;text-align: center;margin-top: 0.5em;font-size: 33px;width:103%;">Bem-vindo(a) ao Plano Experience</h3>
      <aside style="height: 50%;" class="samples d-flex align-items-center justify-content-center">
        <div class="samples-bg">
          <!-- Start SVG -->
          <svg width="334" height="334" viewBox="0 0 334 334" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="16.8125" y="16.8125" width="300.375" height="300.375" rx="50.0625" fill="white" />
            <rect x="16.8125" y="16.8125" width="300.375" height="300.375" rx="50.0625" fill="url(#paint0_linear_1376_701)" />
            <rect x="16.8125" y="16.8125" width="300.375" height="300.375" rx="50.0625" stroke="url(#paint1_linear_1376_701)" stroke-width="33.375" />
            <path
              d="M93.1406 155.219H107.691C112.835 155.219 117.066 154.34 120.387 152.582C123.772 150.759 126.279 148.285 127.906 145.16C129.599 141.97 130.445 138.292 130.445 134.125C130.445 130.023 129.697 126.475 128.199 123.48C126.702 120.421 124.423 118.077 121.363 116.449C118.368 114.757 114.527 113.91 109.84 113.91C106.064 113.91 102.581 114.659 99.3906 116.156C96.2656 117.654 93.7591 119.802 91.8711 122.602C90.0482 125.336 89.1367 128.624 89.1367 132.465H63.2578C63.2578 124.783 65.276 118.044 69.3125 112.25C73.4141 106.391 78.9479 101.801 85.9141 98.4805C92.8802 95.1602 100.66 93.5 109.254 93.5C118.629 93.5 126.832 95.0625 133.863 98.1875C140.96 101.247 146.461 105.772 150.367 111.762C154.339 117.751 156.324 125.173 156.324 134.027C156.324 138.259 155.315 142.491 153.297 146.723C151.344 150.889 148.447 154.665 144.605 158.051C140.829 161.371 136.174 164.073 130.641 166.156C125.172 168.174 118.889 169.184 111.793 169.184H93.1406V155.219ZM93.1406 175.141V161.371H111.793C119.801 161.371 126.734 162.315 132.594 164.203C138.518 166.026 143.401 168.63 147.242 172.016C151.083 175.336 153.915 179.21 155.738 183.637C157.626 188.064 158.57 192.816 158.57 197.895C158.57 204.535 157.333 210.46 154.859 215.668C152.385 220.811 148.902 225.173 144.41 228.754C139.983 232.335 134.775 235.069 128.785 236.957C122.796 238.78 116.318 239.691 109.352 239.691C103.297 239.691 97.4049 238.878 91.6758 237.25C86.0117 235.557 80.901 233.051 76.3438 229.73C71.7865 226.345 68.1732 222.113 65.5039 217.035C62.8346 211.892 61.5 205.935 61.5 199.164H87.3789C87.3789 203.07 88.3229 206.553 90.2109 209.613C92.1641 212.673 94.8333 215.082 98.2188 216.84C101.669 218.533 105.543 219.379 109.84 219.379C114.592 219.379 118.661 218.533 122.047 216.84C125.497 215.082 128.134 212.608 129.957 209.418C131.78 206.163 132.691 202.289 132.691 197.797C132.691 192.458 131.682 188.129 129.664 184.809C127.646 181.488 124.749 179.047 120.973 177.484C117.262 175.922 112.835 175.141 107.691 175.141H93.1406Z"
              fill="url(#paint2_linear_1376_701)"
            />
            <path
              d="M273.316 154.438V178.363C273.316 189.301 272.21 198.643 269.996 206.391C267.783 214.138 264.592 220.486 260.426 225.434C256.259 230.316 251.279 233.93 245.484 236.273C239.69 238.552 233.245 239.691 226.148 239.691C220.484 239.691 215.211 238.975 210.328 237.543C205.445 236.046 201.051 233.767 197.145 230.707C193.303 227.582 189.983 223.611 187.184 218.793C184.449 213.975 182.333 208.214 180.836 201.508C179.404 194.802 178.688 187.087 178.688 178.363V154.438C178.688 143.5 179.794 134.19 182.008 126.508C184.286 118.826 187.509 112.543 191.676 107.66C195.842 102.777 200.823 99.2292 206.617 97.0156C212.411 94.737 218.857 93.5977 225.953 93.5977C231.682 93.5977 236.956 94.3138 241.773 95.7461C246.656 97.1784 251.018 99.4245 254.859 102.484C258.766 105.479 262.086 109.385 264.82 114.203C267.555 118.956 269.638 124.685 271.07 131.391C272.568 138.031 273.316 145.714 273.316 154.438ZM247.535 181.879V150.824C247.535 145.355 247.21 140.603 246.559 136.566C245.973 132.465 245.094 128.982 243.922 126.117C242.75 123.253 241.285 120.941 239.527 119.184C237.77 117.361 235.751 116.026 233.473 115.18C231.194 114.333 228.688 113.91 225.953 113.91C222.568 113.91 219.54 114.594 216.871 115.961C214.202 117.263 211.956 119.346 210.133 122.211C208.31 125.076 206.91 128.884 205.934 133.637C205.022 138.324 204.566 144.053 204.566 150.824V181.879C204.566 187.348 204.859 192.133 205.445 196.234C206.096 200.336 207.008 203.852 208.18 206.781C209.417 209.711 210.882 212.12 212.574 214.008C214.332 215.831 216.35 217.198 218.629 218.109C220.908 218.956 223.414 219.379 226.148 219.379C229.599 219.379 232.626 218.695 235.23 217.328C237.9 215.961 240.146 213.812 241.969 210.883C243.792 207.888 245.159 204.014 246.07 199.262C247.047 194.444 247.535 188.65 247.535 181.879Z"
              fill="url(#paint3_linear_1376_701)"
            />
            <defs>
              <linearGradient id="paint0_linear_1376_701" x1="167" y1="33.5" x2="167" y2="300.5" gradientUnits="userSpaceOnUse">
                <stop stop-color="#6024BE" />
                <stop offset="1" stop-color="#290069" />
              </linearGradient>
              <linearGradient id="paint1_linear_1376_701" x1="167" y1="33.5" x2="167" y2="300.5" gradientUnits="userSpaceOnUse">
                <stop stop-color="#752DE6" />
                <stop offset="1" stop-color="#5500CC" />
              </linearGradient>
              <linearGradient id="paint2_linear_1376_701" x1="119.643" y1="52.7383" x2="119.643" y2="286.738" gradientUnits="userSpaceOnUse">
                <stop stop-color="#C199FF" />
                <stop offset="1" stop-color="#5500CC" />
              </linearGradient>
              <linearGradient id="paint3_linear_1376_701" x1="119.643" y1="52.7383" x2="119.643" y2="286.738" gradientUnits="userSpaceOnUse">
                <stop stop-color="#C199FF" />
                <stop offset="1" stop-color="#5500CC" />
              </linearGradient>
            </defs>
          </svg>
          <!-- End SVG -->
        </div>
      </aside>
      <p
        style="
    color: white;
    font-size: 18px;
    font-weight: bold;
    margin-top: -1em;"
      >
      Com a Multicanalidade + Agentes de IA da Yup Chat, você garante: <br>
</p>
<ul class="benefits-list" style="color: white;list-style: none;">
  <li>✅ +40% de produtividade para sua equipe</li>
  <li>✅ +60% de eficiência operacional</li>
  <li>✅ -50% no tempo de resposta</li>
  <li>✅ +35% de vendas qualificadas</li>
</ul>

<p style="color: white; font-weight: bold; font-size: 18px;">Sem custo. Sem burocracia. Só resultados. 🚀</p>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { load } from 'recaptcha-v3';
import DarkMode from '@/assets/mixins/detectDark';
import OptLangRadio from '@/components/OptLangRadio.vue';
import OptLangDropdown from '@/components/OptLangDropdown.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import Logo from '@/assets/logo-v2.svg';

export default {
  name: 'AuthIntro',
  components: {
    // OptLangRadio,
    ButtonComponent,
    OptLangDropdown,
  },
  mixins: [DarkMode],
  watch: {
    $route(to, from) {
      // if (from.path === '/2fa') {
      //   this.routing = true;
      // } else if (to.path === '/login') {
      //   this.routing = false;
      // }

      if (to.path === '/login') {
        this.routing = false;
      }
    },
  },
  beforeDestroy() {
    // Opcional: Remover os elementos quando o componente for destruído
    const noscripts = document.querySelectorAll('noscript');
    noscripts.forEach((ns) => {
      if (ns.innerHTML.includes('GTM-MGNRTWCL')) {
        ns.remove();
      }
    });
  },
  data() {
    return {
      routing: this.$router.currentRoute.path !== '/login',
      logo: null,
    };
  },
  computed: {
    whitelabelReady() {
      return !!this.$store?.state?.admin?.whitelabel?.id;
    },
    whitelabelLogo() {
      return this.$store?.state?.admin?.whitelabel?.logo ?? Logo;
    },
    whitelabel() {
      return this.$store?.state?.admin?.whitelabel ?? null;
    },
  },
  mounted() {
    const hostname = window.location.hostname;

    switch (hostname) {
      case 'smsycorporativo.algartelecom.com.br':
        this.companyName = 'Algar Telecom';
        break;
      default:
        console.info('Default favicon');
    }

    // Adiciona o script do GTM no head
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-MGNRTWCL');`;
    document.head.appendChild(script);

    // Adiciona o noscript no body
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-MGNRTWCL';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
  },
  methods: {
    async launchRegister() {
      await this.$router.push('/register');
      this.routing = true;
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  height: 120vh;
  padding: 0; // Remove the padding from main

  .top-options {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3em;
  }

  .benefits-list {
    margin-left: -40px;
  } & li {
    font-size: 16px;
  }

  .left-column {
    background-color: white;
    padding: 53px 37px;

    @media (min-width: 768px) {
      padding: 50px 180px;
    }

    @media (max-width: 1500px) {
      padding: 50px 50px;
    }
  }

  .right-column {
    background: radial-gradient(63.72% 70.71% at 50% 50%, #6e3dbc 0%, #4b1d93 100%);
    padding: 39px 23px;

    @media (min-width: 768px) {
      padding: 115px 180px;
    }

    @media (max-width: 1500px) {
      padding: 50px 50px;
    }
  }

  header {
    margin-bottom: 66px;
  }

  .logo {
    width: 126px;
    height: 30px;
  }

  .sub-intro {
    margin-top: 10vh;

    h1 {
      font-size: 23px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-align: center;

      @media (min-width: 768px) {
        font-size: 50px;
        text-align: left;
      }
    }

    h2 {
      color: #747374;
      font-size: 19px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-align: center;

      @media (min-width: 768px) {
        font-size: 32px;
        text-align: left;
      }
    }
  }
}
</style>
